import mergeWith from 'lodash/mergeWith'
import isArray from 'lodash/isArray'

function customizer(objValue, srcValue) {
  if (isArray(srcValue)) {
    return srcValue
  }
}

export function deepAssign(object, other) {
  return mergeWith(object, other, customizer)
};
